export default "/images/movie_4K.svg?52107e4cdb234d10de26ad3ade16d94d";